const TAIICHI_OHNO = 'Taiichi Ohno - Creador del Sistema de Producción Toyota';
const HENRY_FORD = 'Henry Ford - Fundador de Ford Motor Company';
const ED_DEMING = 'Edward Deming - Creador del ciclo PDCA';

export const HAVING_NO_PROBLEMS = 'El mayor problema es no tener problemas.';
export const HAVING_NO_PROBLEMS_SOURCE = TAIICHI_OHNO;

export const FORCE_STANDARDS = 'Los estándares no deben imponerse desde la alta dirección, sino que deben establecerlos quienes trabajan sobre el terreno, es decir, en el lugar de producción.';
export const FORCE_STANDARDS_SOURCE = TAIICHI_OHNO;

export const WASTE = 'El despilfarro es lo contrario a tener un mínimo imprescindible de maquinaria, materiales, piezas y tiempo de trabajo, algo totalmente fundamental para la creación de productos o servicios.';
export const WASTE_SOURCE = TAIICHI_OHNO;

export const ALWAYS_DO_WHAT_ALWAYS_DID = 'Si sigue haciendo las cosas como siempre, volverá a obtener el mismo resultado de siempre.';
export const ALWAYS_DO_WHAT_ALWAYS_DID_SOURCE = HENRY_FORD;

export const FIND_FAULT = 'No busque el error, sino la solución.';
export const FIND_FAULT_SOURCE = HENRY_FORD;

export const BAD_SYSTEM = 'Un mal sistema acabará imponiéndose siempre, por muy bueno que sea quien esté detrás.';
export const BAD_SYSTEM_SOURCE = ED_DEMING;

export const WITHOUT_DATA = 'Sin datos, solo será alguien con una opinión.';
export const WITHOUT_DATA_SOURCE = ED_DEMING;

export default {
  HAVING_NO_PROBLEMS,
  HAVING_NO_PROBLEMS_SOURCE,
  FORCE_STANDARDS,
  FORCE_STANDARDS_SOURCE,
  WASTE,
  WASTE_SOURCE,
  ALWAYS_DO_WHAT_ALWAYS_DID,
  ALWAYS_DO_WHAT_ALWAYS_DID_SOURCE,
  FIND_FAULT,
  FIND_FAULT_SOURCE,
  BAD_SYSTEM,
  BAD_SYSTEM_SOURCE,
  WITHOUT_DATA,
  WITHOUT_DATA_SOURCE,
}
